// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"446f7e10","513":"4fe8456d","703":"14df0bc2","787":"37ba09b0"}[chunkId] + ".chunk.js";
};